import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ApiService } from 'app/shared/apis/api.service';
import { CompanyService } from 'app/services/company.service';
import { map, switchMap, take } from 'rxjs';

export const RequesterGuard: CanActivateFn = () => {
    const router = inject(Router);
    const companyService = inject(CompanyService);

    return ApiService.userCurrent.pipe(
        take(1),
        switchMap((user) => {
            companyService.rememberOperationalCompanyIfNeeded();
            return companyService.resolveFirstRequesterCompanyForPortal(!!user?.is_admin).pipe(
                map((company) => {
                    if (!company) {
                        return user?.is_admin ? true : router.parseUrl('/home');
                    }
                    const current = companyService.getCurrentCompany();
                    if (Number(current?.company_id) !== Number(company.company_id)) {
                        companyService.setCurrentCompany(company);
                    }
                    return true;
                }),
            );
        }),
    );
};
